/**
 * Spreads de Crédito (migrada do Streamlit; equivalência em
 * backend/tests_paginas/test_spreads_credito.py).
 * Período: o mesmo seletor de B3 · Fluxo, mais Completo (a série inteira).
 */
import { PaginaComAbas } from '../../components/PaginaComAbas';
import { opcoesPeriodo } from '../../lib/periodos';

// Usados enquanto a primeira resposta não chega; a API devolve a lista definitiva.
const PERIODOS = opcoesPeriodo(['ytd', '30d', '6m', '1a', '2a', 'max']);

export function SpreadsCredito() {
  return (
    <PaginaComAbas
      descricao="Spreads e duration de debêntures por indexador: evolução, distribuição por faixa, contagem de ativos e volume emitido."
      fonte="Banco Persevera (indicadores)"
      tituloSecao="Spreads e duration por indexador"
      legendaSecao="Uma aba por indexador. Duration em anos, com média, mediana e média ponderada pelo volume."
      titulo="Spreads de Crédito"
      caminho="/credito-privado/spreads-de-credito"
      filtro={{ tipo: 'periodo', padrao: 'ytd', grupo: 'Histórico', periodos: PERIODOS }}
    />
  );
}
